import { UpperScreen } from "../../../../actions/terminal";
import { broadcast, broadcastChannels } from "../../../../helpers/broadcast";
import Helpers from "../../../../helpers/helperFunctions";
import { store } from "../../../../index/terminalApp";

class LotoHandler {
    openStream(visualLink) {
        Helpers.isSplitScreenAvailable()
            ? broadcast.dispatchEvent(new CustomEvent(broadcastChannels.SplitScreenChange, {
                detail: { command: 'ThirdParty', url: visualLink }
            })) : store.dispatch(UpperScreen({
                type: 'ThirdParty',
                id: 111, //doesn't matter what id
                videoURL: visualLink,
                tv_type: 21,
            }));
    }

    openDefault() {
        Helpers.isSplitScreenAvailable()
            ? broadcast.dispatchEvent(new CustomEvent(broadcastChannels.SplitScreenChange, {
                detail: { command: 'Default', id: 0, url: "", providerId: 0 }
            })) : store.dispatch(UpperScreen({ type: "Default", id: 0, videoURL: "", tv_type: 0 }));
    }

    onIframeMessage({ data }) {
        if (typeof data !== 'object') return;

        if (data.type === 'no-stream') return this.openDefault();
        
        if ('visualLink' in data) return this.openStream(data.visualLink);
    }
};

export default LotoHandler;